import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutBreakthroughFuelHistoryDetail } from "./autogen/AutogenLayoutBreakthroughFuelHistoryDetail";

export class BreakthroughFuelHistoryDetail extends AutogenLayoutBreakthroughFuelHistoryDetail {
    
    /** This is an event handler for the afterExecution event of sourceBreakthroughHistory. */
    sourceBreakthroughHistoryAfterExecution(event: DataSourceExecutionEvent) {
        const orderId = this.activeRow.get("order_id");
        if (orderId) {
            this.activeRow.setLookupModelData("order_id", { id: orderId });
        }
    }
}
